// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#exam[data-v-2fb551a8] {\r\n  border-radius: 6px;\n}\n.payment[data-v-2fb551a8] {\r\n  font-size: 12px;\n}\n.text[data-v-2fb551a8] {\r\n  font-size: 0.6rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
